<template>
  <v-form v-model="form_validate_status" ref="form">
    <v-card
      class="mx-auto"
      max-width="900"
      :loading="loading"
      :disabled="loading"
    >
      <v-card-title class="d-flex flex-column">
        <h1>{{ $t("questionnaire.title") }}</h1>
        <h5 class="mt-2">
          {{ $t("pre_regis_panel.semester") }} {{ semester }} / {{ year }}
        </h5>
      </v-card-title>

      <!-- ระดับความพึงพอใจ -->
      <v-card-text class="px-1 px-sm-3 px-xl-6">
        <v-row>
          <v-col class="v-col-12 v-col-sm-12">
            <h2 class="text-primary">
              {{ $t("questionnaire.level_satisfaction_user") }}
            </h2>
          </v-col>
        </v-row>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-right" colspan="3">
                  {{ $t("questionnaire.header_table2") }}
                  <!-- <p>{{ $t("questionnaire.header_table2_hint") }}</p> -->
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="question">
                  {{ $t("questionnaire.Q1") }}
                </td>
                <td>
                  <RatingCard v-model="Q1" :rules="requiredRules" />
                </td>
                <td class="text-nowrap">
                  <span class="text-tag-5 text-no-wrap">
                    ({{ Q1 ? Q1 : $t("questionnaire.please_rate") }})
                  </span>
                </td>
              </tr>
              <tr>
                <td class="question">
                  {{ $t("questionnaire.Q2") }}
                </td>
                <td>
                  <RatingCard v-model="Q2" :rules="requiredRules" />
                </td>
                <td class="text-nowrap">
                  <span class="text-tag-5 text-no-wrap">
                    ({{ Q2 ? Q2 : $t("questionnaire.please_rate") }})
                  </span>
                </td>
              </tr>
              <tr>
                <td class="question">
                  {{ $t("questionnaire.Q3") }}
                </td>
                <td>
                  <RatingCard v-model="Q3" :rules="requiredRules" />
                </td>
                <td class="text-nowrap">
                  <span class="text-tag-5 text-no-wrap">
                    ({{ Q3 ? Q3 : $t("questionnaire.please_rate") }})
                  </span>
                </td>
              </tr>
              <tr>
                <td class="question">
                  {{ $t("questionnaire.Q4") }}
                </td>
                <td>
                  <RatingCard v-model="Q4" :rules="requiredRules" />
                </td>
                <td class="text-nowrap">
                  <span class="text-tag-5 text-no-wrap">
                    ({{ Q4 ? Q4 : $t("questionnaire.please_rate") }})
                  </span>
                </td>
              </tr>
              <tr>
                <td class="question">
                  {{ $t("questionnaire.Q5") }}
                </td>
                <td>
                  <RatingCard v-model="Q5" :rules="requiredRules" />
                </td>
                <td class="text-nowrap">
                  <span class="text-tag-5 text-no-wrap">
                    ({{ Q5 ? Q5 : $t("questionnaire.please_rate") }})
                  </span>
                </td>
              </tr>
              <tr>
                <td class="question">
                  {{ $t("questionnaire.Q6") }}
                </td>
                <td>
                  <RatingCard v-model="Q6" :rules="requiredRules" />
                </td>
                <td class="text-nowrap">
                  <span class="text-tag-5 text-no-wrap">
                    ({{ Q6 ? Q6 : $t("questionnaire.please_rate") }})
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>

      <v-divider></v-divider>

      <!-- ข้อมูลเพิ่มเติม -->
      <v-card-text class="px-1 px-sm-3 px-xl-6">
        <v-row>
          <v-col class="v-col-12 v-col-sm-12">
            <h2 class="text-primary">
              {{ $t("questionnaire.additional_info") }}
            </h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="v-col-12 v-col-sm-12">
            <h5>
              <span class="red--text" v-if="!hasEnoughStar">*</span>
              {{ $t("questionnaire.additional") }}
            </h5>
            <v-text-field
              v-model="COMMENT"
              :rules="hasEnoughStar ? [] : requiredRulesTextarea"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="px-1 px-sm-3 px-xl-6 d-flex flex-column">
        <v-btn
          size="large"
          color="success"
          :disabled="!form_validate_status"
          @click="saveData"
          >SAVE</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { objectTranslator } from "@/helper/translator";
import RatingCard from "@/components/info_cards/RatingView.vue";
import validator from "@/helper/validator";
import QuestionnaireProvider from "@/services/questionnaire.provider";
const questionnaireService = new QuestionnaireProvider();

export default {
  name: "QuestionView",

  components: { RatingCard },

  data: () => ({
    loading: false,
    form_validate_status: null,

    Q1: null,
    Q2: null,
    Q3: null,
    Q4: null,
    Q5: null,
    Q6: null,
    COMMENT: null,

    requiredRules: [validator.required],
    // intGratterZeroRules: [validator.int_gratter_zero],
    requiredRulesTextarea: [validator.required, validator.minChar(50)],
  }),

  methods: {
    objectTranslator,

    async fetch_data() {
      this.loading = true;

      await this.$store.dispatch(
        "registration/getYearSemesterNow",
        this.level_id
      );
      await this.$store.dispatch("questionnaire/getQuestionnaire", {
        student_id: this.student_id,
        year: this.year,
        semester: this.semester,
      });
      this.Q1 = parseInt(this.questionnaire.Q1);
      this.Q2 = parseInt(this.questionnaire.Q2);
      this.Q3 = parseInt(this.questionnaire.Q3);
      this.Q4 = parseInt(this.questionnaire.Q4);
      this.Q5 = parseInt(this.questionnaire.Q5);
      this.Q6 = parseInt(this.questionnaire.Q6);
      this.COMMENT = this.questionnaire.COMMENT;

      this.loading = false;
    },

    async saveData() {
      this.loading = true;

      const response = await questionnaireService
        .setQuestionnaire({
          student_id: this.student_id,
          year: this.year,
          semester: this.semester,

          Q1: this.Q1,
          Q2: this.Q2,
          Q3: this.Q3,
          Q4: this.Q4,
          Q5: this.Q5,
          Q6: this.Q6,
          COMMENT: this.COMMENT,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });
      if (response && response.status) {
        this.$toasted.success(this.$t("toasted.save_successfully"));
        this.fetch_data();
      } else
        this.$toasted.error(this.$t("toasted.cannot_save"), {
          duration: 0,
        });

      this.loading = false;
    },
  },

  computed: {
    year() {
      return this.$store.state.registration.yearNow;
    },

    semester() {
      return this.$store.state.registration.semesterNow;
    },

    student_id() {
      return this.$store.state.user.surrogated_student_id;
    },

    level_id() {
      if (
        this.$store.state.user.surrogated_student_info.payload.ticket
          .privilege == 80
      )
        return 1;
      else return 2;
    },

    questionnaire() {
      return this.$store.state.questionnaire.data;
    },

    hasEnoughStar() {
      let data = false;
      if (
        parseInt(this.Q1) +
          parseInt(this.Q2) +
          parseInt(this.Q3) +
          parseInt(this.Q4) +
          parseInt(this.Q5) +
          parseInt(this.Q6) >=
        18
      ) {
        data = true;
      }
      return data;
    },
  },

  watch: {},

  created() {
    this.fetch_data();
    this.loading = true;
  },
};
</script>

<style scoped>
th,
td {
  border-left-width: 0px;
  padding: 0px 5px !important;
}

.question {
  min-width: 250px;
  text-indent: 15px;
}
</style>
